// Central query-key factory. Always include every param that affects the
// response (currency, pagination, filters) so the cache keys stay correct.
//
// Keys are added here as resources are migrated. Notifications are first
// because they ship in the Pilot phase.

export const queryKeys = {
  notifications: {
    list: () => ["notifications", "list"] as const,
    unreadCount: () => ["notifications", "unread-count"] as const,
  },

  // Added during Phase 1 / Phase 2:
  profile: () => ["user", "profile"] as const,
  orders: (params?: Record<string, any>) => ["orders", params] as const,
  walletTransactions: (params?: Record<string, any>) =>
    ["wallet-transactions", params] as const,
  withdrawals: (params?: Record<string, any>) =>
    ["withdrawals", params] as const,
  withdrawalDetail: (id?: string) => ["withdrawals", "detail", id] as const,
  walletDeduction: (id?: string) => ["wallet-deduction", id] as const,
  business: () => ["user", "business"] as const,
  referrals: () => ["user", "referrals"] as const,
  banks: () => ["user", "banks"] as const,
  bankAccounts: () => ["bank-account"] as const,
  quicklinks: (params?: Record<string, any>) =>
    ["quicklinks", params] as const,
  quicklinkDetail: (name?: string) => ["quicklinks", "detail", name] as const,
  openLink: () => ["quicklinks", "merchant", "open-link"] as const,
  storeProducts: (storeId?: string, params?: Record<string, any>) =>
    ["store", storeId, "products", params] as const,
  storeCategories: (storeId?: string) =>
    ["store", storeId, "categories"] as const,
  storeProduct: (storeId?: string, productId?: string) =>
    ["store", storeId, "product", productId] as const,
  catalogCategories: () => ["catalog", "categories"] as const,
  catalogProducts: (params?: Record<string, any>) =>
    ["catalog", "product", params] as const,
  catalogProduct: (id?: string) => ["catalog", "product", "detail", id] as const,
  order: (id?: string) => ["orders", "detail", id] as const,
  orderTimeline: (id?: string, currency?: string) =>
    ["orders", "detail", id, "timeline", currency] as const,
  orderCancelRequest: (id?: string) =>
    ["orders", "detail", id, "cancel-request"] as const,
  wallet: {
    balance: (currency?: string) => ["wallet", "balance", currency] as const,
    escrow: (currency?: string) => ["wallet", "escrow", currency] as const,
  },
  revenue: (currency?: string) => ["user", "revenue", currency] as const,
};
